import React, { useRef } from 'react'

import { HeaderNav, MapStrapiComponentToSubMenuType, subMenuType } from '@application/Types/HeaderTypes'
import { Link } from '@src/Application/Interfaces/Atoms/Link'
import { DynamicColumnSubMenu } from '@src/Application/Interfaces/Features/Header/Nav/DynamicColumnSubMenu'

import { NavItem, NavItemButton, NavItemLink, NavItemLinkLabel, SubMenuWrapper } from './Nav.styled'
import { ThreeColumnSubMenu } from './ThreeColumnSubMenu'
import { TwoColumnSubMenu } from './TwoColumnSubMenu'
import { positionSubmenu } from './utils'

export const NavItemElement = ({ index, node }: { index: number; node: HeaderNav }) => {
    const submenuRef = useRef(null)

    return (
        <NavItem key={`desktop-nav-${index}`} onMouseEnter={positionSubmenu(submenuRef)}>
            {(!node.submenu || Boolean(node.submenu.length === 0)) && node.linkStyle !== 'button' && (
                <NavItemLink to={node.link}>{node.label}</NavItemLink>
            )}
            {(!node.submenu || Boolean(node.submenu.length === 0)) && node.linkStyle === 'button' && (
                <Link to={node.link}>
                    <NavItemButton size="small">{node.label}</NavItemButton>
                </Link>
            )}
            {node.submenu && Boolean(node.submenu.length > 0) && <NavItemLinkLabel>{node.label}</NavItemLinkLabel>}
            {node.submenu?.map((sub, j) => {
                const type = MapStrapiComponentToSubMenuType[sub.strapi_component]
                return (
                    <SubMenuWrapper key={sub.id} type={type} ref={submenuRef}>
                        {type === subMenuType['two-columns-submenu'] && <TwoColumnSubMenu {...sub} />}
                        {type === subMenuType['three-columns-submenu'] && <ThreeColumnSubMenu {...sub} />}
                        {type === subMenuType['dynamic-columns'] && <DynamicColumnSubMenu {...sub} />}
                    </SubMenuWrapper>
                )
            })}
        </NavItem>
    )
}
